import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiService, ENVIRONMENT_CONFIG } from '@meddatacore/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { ChangePassword, Person, RegisterUser, SetPassword, UserContact } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserService extends ApiService {
  currentUserContact$: BehaviorSubject<UserContact> = new BehaviorSubject(null);
  currentPerson$: BehaviorSubject<Person> = new BehaviorSubject(null);
  get person() {
    var _person = this.currentPerson$.getValue();
    return _person;
  }
  get userContact() {
    var _contact = this.currentUserContact$.getValue();
    return _contact;
  }
  constructor(http: HttpClient, @Inject(ENVIRONMENT_CONFIG) environment) {
    super(http, environment);
    if (this.userContact == null) {
      this.getUserContact().subscribe((s: UserContact) => {
        this.currentUserContact$.next(s);
        return s;
      })
    }
    if (this.person == null) {
      this.getUserPerson().subscribe((s: Person) => {
        this.currentPerson$.next(s);
        return s;
      })
    }
  }
  getUserPerson() {
    return this.http.get(`${this.persionBaseURL}/api/persons/user/person`);
  }

  regiser(data: RegisterUser) {
    return this.http.post(this.identityBaseUrl + "/api/users/register", data);
  }

  changePassword(data: ChangePassword) {
    return this.http.post(this.identityBaseUrl + "/api/users/change-password", data);
  }
  setPassword(data: SetPassword) {
    return this.http.post(this.identityBaseUrl + "/api/users/set-password", data);
  }
  getUserContact() {
    return this.http.get(this.identityBaseUrl + "/api/users/contact");
  }

  changeImage(file: string) {
    return this.http.post(this.identityBaseUrl + "/api/users/changeImage", { base64String: file });
  }

  setActiveClinic(clinicId: string) {
    return this.http.post(this.identityBaseUrl + "/api/users/active-clinic", { clinicId });
  }
  setActivePosition(clinicId: string, positionId: string, warehouseId: string) {
    return this.http.post(this.identityBaseUrl + "/api/users/active-position", { clinicId, positionId, warehouseId });
  }
  setActivePositionAndWorkplace(params:any) {
    return this.http.post(this.identityBaseUrl + "/api/users/active-position", {...params});
  }
  getUsersByPersonId(personId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.identityBaseUrl}/api/users/getUsersByPersonId/${personId}`);
  }
  getPersonUsers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.identityBaseUrl}/api/users/getPersonUsers`);
  }
  getCurrentEmployee(): Observable<any> {
    return this.http.get<any>(`${this.clinicsBaseURL}/api/employees/getCurrentEmployee`);
  }
}
